import * as yup from 'yup';

// ==================== INTERFACES ====================
export interface Screening {
  employeeId: string;
  employeeName: string;
  email: string;
  avatar?: string;
  competency?: string;
  status: boolean;
  isDelete: boolean;
}

export interface UnitClass {
  id: string;
  name: string;
  type: 'Income' | 'Growth';
  unitPrice: number;
  totalUnits: number;
  totalNAV: number;
  description: string;
  features: string[];
  riskLevel: string;
  minimumInvestment: number;
  subscriptionType: 'incomeUnits' | 'growthUnits';
}

export interface SubscriptionFormData {
  investorName: string;
  investorsEmailId: string;
  investorAvatar?: string | null;
  calculationType: 'amount' | 'units';
  purchaseUnits: number;
  totalInvestmentAmt: number;
  subscriptionType: 'incomeUnits' | 'growthUnits';
}

export interface OperationalFees {
  incomeUnits: number;
  growthUnits: number;
}

export interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'info';
}

// ==================== VALIDATION SCHEMA ====================
export const validationSchema = yup.object({
  investorName: yup.string().ensure(),
  investorsEmailId: yup.string().ensure(),
  investorAvatar: yup.string().nullable().notRequired(),
  calculationType: yup
    .string()
    .oneOf(['amount', 'units'], 'Invalid calculation type')
    .required('Calculation type is required'),
  purchaseUnits: yup.number().positive('Units must be positive').required('Units are required'),
  totalInvestmentAmt: yup
    .number()
    .positive('Investment amount must be positive')
    .required('Investment amount is required'),
  subscriptionType: yup
    .string()
    .oneOf(['incomeUnits', 'growthUnits'], 'Invalid subscription type')
    .required('Purchase type is required')
});

// ==================== INITIAL DATA ====================
export const getInitialUnitClasses = (): UnitClass[] => [
  {
    id: 'initial-income',
    name: 'Income Units',
    type: 'Income',
    unitPrice: 1.0,
    totalUnits: 0,
    totalNAV: 0,
    description:
      'Conservative investment focused on regular income generation through quarterly distributions',
    features: [
      'Regular quarterly distributions',
      'Lower volatility',
      'Stable income stream',
      'Conservative investment approach'
    ],
    riskLevel: 'Conservative',
    minimumInvestment: 10000,
    subscriptionType: 'incomeUnits'
  },
  {
    id: 'initial-growth',
    name: 'Growth Units',
    type: 'Growth',
    unitPrice: 1.0,
    totalUnits: 0,
    totalNAV: 0,
    description:
      'Growth-focused investment for long-term capital appreciation with higher risk tolerance',
    features: [
      'Capital growth focus',
      'Higher growth potential',
      'Reinvested earnings',
      'Long-term wealth building'
    ],
    riskLevel: 'Moderate to High',
    minimumInvestment: 15000,
    subscriptionType: 'growthUnits'
  }
];
